<template>
  <div class="temp-login-form">
    <div class="justify-center flex mb50">
      <h2 class="text-primary">Log in</h2>
    </div>
    <vs-input
      icon="icon icon-users"
      icon-pack="feather"
      placeholder="Name"
      v-model="name"
      class="w-full"
      name="input1"
    />
    <vs-input
      type="password"
      icon="icon icon-lock"
      icon-pack="feather"
      placeholder="Password"
      v-model="password"
      class="w-full mt-6"
      @keyup.enter.native="login"
    />
    <div class="flex flex-end mt-5">
      <vs-button :disabled="!btnDis" @click.prevent="login">Login</vs-button>
    </div>
  </div>
</template>

<script>
// import VConsole from 'vconsole';
// let vConsole = new VConsole();
import axios from 'axios';
import $ from 'jQuery'
export default {
  data () {
    return {
      name: '',
      password: '',
    }
  },
  computed: {
    btnDis () {
      return this.password && this.name;
    }
  },

  created () {

  },
  methods: {
    login () {
      this.$vs.loading()
      this.$api.login({
        name: this.name,
        password: this.password
      }).then(res => {
        this.$vs.loading.close()
        if (res.data.code == 200) {
          localStorage.setItem('token', res.data.data.token);
          localStorage.setItem('user', JSON.stringify(res.data.data.user));
          this.$router.push('/home')
        } else {
          this.$vs.notify({
            color: "danger",
            icon: 'error',
            text: res.data.message,
            position: "top-center"
          })
        }
      })
    }
  }
}

</script>


<style lang="scss">
.temp-login-form {
  padding: 55px 30px;
}
</style>
